define('collections/questionnaire/comments',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // models
    'models/questionnaire/comment'
], function(
    _, Backbone, U,
    // services
    API,
    // models
    MComment
) {

    var CComments = Backbone.Collection.extend({
        model: MComment,

    });

    return CComments;

});

